/** CSS fragment shared by horizontal carousel tracks (GPU layer + drag offset var). */
export const CAROUSEL_DRAG_OFFSET = 'var(--carousel-drag-offset, 0px)';

export function carouselTrackTransform(translateExpr) {
  return {
    transform: `translate3d(calc(${translateExpr} + ${CAROUSEL_DRAG_OFFSET}), 0, 0)`,
  };
}

/** Drag-only layer used by PostsCarousel (slide positions live on children). */
export function carouselDragLayerStyle() {
  return {
    transform: `translate3d(${CAROUSEL_DRAG_OFFSET}, 0, 0)`,
  };
}
